import React from "react";
import LegalPage, { LegalH2, LegalP } from "../components/LegalPage";
import { useSeo } from "../hooks/useSeo";

export default function Impressum() {
  useSeo({
    title: "Impressum – Hype Hafen | Social Media Agentur Hamburg",
    description:
      "Impressum und rechtliche Angaben nach § 5 TMG der Hype Hafen Social Media Agentur aus Hamburg. Inhaber, Anschrift, Kontakt und Verantwortlicher.",
  });

  return (
    <LegalPage title="Impressum" eyebrow="Rechtliche Angaben">
      <LegalH2>Angaben gemäß § 5 TMG</LegalH2>
      <LegalP>
        Hype Hafen
        <br />
        Inhaber: Sardaar Enis-Khan Rafiq
        <br />
        Traute-Lafrenz-Straße 161
        <br />
        22297 Hamburg
        <br />
        Deutschland
      </LegalP>

      <LegalH2>Kontakt</LegalH2>
      <LegalP>
        Telefon: <a href="tel:+4915560931517" className="text-[#2185D0] underline underline-offset-2">+49 155 60931517</a>
        <br />
        E-Mail:{" "}
        <a href="mailto:kontakt@hype-hafen.de" className="text-[#2185D0] underline underline-offset-2">
          kontakt@hype-hafen.de
        </a>
        <br />
        Website:{" "}
        <a href="https://hype-hafen.de" className="text-[#2185D0] underline underline-offset-2">
          HypeHafen.de
        </a>
      </LegalP>

      <LegalH2>Unternehmensform</LegalH2>
      <LegalP>Einzelunternehmen</LegalP>

      <LegalH2>Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz</LegalH2>
      <LegalP>
        Die Umsatzsteuer-Identifikationsnummer wurde beantragt und wird nach Erteilung ergänzt.
      </LegalP>

      <LegalH2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</LegalH2>
      <LegalP>
        Sardaar Enis-Khan Rafiq
        <br />
        Traute-Lafrenz-Straße 161
        <br />
        22297 Hamburg
      </LegalP>

      <LegalH2>EU-Streitschlichtung</LegalH2>
      <LegalP>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#2185D0] underline underline-offset-2"
        >
          https://ec.europa.eu/consumers/odr/
        </a>
        .<br />
        Unsere E-Mail-Adresse findest du oben im Impressum.
      </LegalP>

      <LegalH2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</LegalH2>
      <LegalP>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </LegalP>

      <LegalH2>Haftung für Inhalte</LegalH2>
      <LegalP>
        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen
        Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir
        als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
        Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
        rechtswidrige Tätigkeit hinweisen.
      </LegalP>
      <LegalP>
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
        allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist
        jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
        Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte
        umgehend entfernen.
      </LegalP>

      <LegalH2>Haftung für Links</LegalH2>
      <LegalP>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir
        keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
        Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
        Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum
        Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige
        Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
        inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte
        einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen
        werden wir derartige Links umgehend entfernen.
      </LegalP>

      <LegalH2>Urheberrecht</LegalH2>
      <LegalP>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
        unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
        Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
        bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
        Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen
        Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber
        erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden
        Inhalte Dritter als solche gekennzeichnet. Solltest du trotzdem auf eine
        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden
        Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte
        umgehend entfernen.
      </LegalP>

      <LegalH2>Bildnachweise</LegalH2>
      <LegalP>
        Verwendete Bilder stammen aus eigenen Aufnahmen sowie aus lizenzierten
        Bildquellen (u. a. Unsplash, Pexels). Die jeweiligen Lizenzbedingungen werden
        eingehalten.
      </LegalP>
    </LegalPage>
  );
}
